import pkg from '../../package.json';

const stripQuotes = value => {
  if (!value) return value;
  return value.replace(/^["']|["']$/g, '');
};

const commitSha = stripQuotes(process.env.VITE_COMMIT_SHA) || 'unknown';

export default {
  idleTimeout: stripQuotes(process.env.VITE_IDLE_MINUTES_BEFORE_LOGOUT),
  partnerHub: stripQuotes(process.env.VITE_IDLE_PARTNER_HUB_URL),
  apiUrl: stripQuotes(process.env.VITE_API_URL),
  drmApiUrl: stripQuotes(process.env.VITE_DRM_API_URL) || stripQuotes(process.env.VITE_API_URL),
  cashflowApiUrl: stripQuotes(process.env.VITE_CASHFLOW_API_URL),
  admin: stripQuotes(process.env.VITE_ADMIN_URL) || stripQuotes(process.env.VITE_API_URL),
  host: stripQuotes(process.env.VITE_HOST_URL) || 'https://chaserhq.com',
  helpCentre: stripQuotes(process.env.VITE_HELP_CENTRE_URL) || 'https://help.chaserhq.com',
  sentry: stripQuotes(process.env.VITE_SENTRY_URL) || 'https://sentry.chaserhq.com',
  sentryDsn: stripQuotes(process.env.VITE_SENTRY_DSN),
  sentryEnvironment: stripQuotes(process.env.VITE_SENTRY_ENVIRONMENT),
  cspReportUri: stripQuotes(process.env.VITE_CSP_REPORT_URL),
  stripePublishableKey: stripQuotes(process.env.VITE_STRIPE_PUBLISHABLE_KEY),
  chargebeeSite: stripQuotes(process.env.VITE_CHARGEBEE_SITE_NAME),
  firebaseProjectId: stripQuotes(process.env.VITE_FIREBASE_PROJECT_ID),
  firebaseApiKey: stripQuotes(process.env.VITE_FIREBASE_API_KEY),
  firebaseAppId: stripQuotes(process.env.VITE_FIREBASE_APP_ID),
  pendoAgentId: stripQuotes(process.env.VITE_PENDO_AGENT_ID),
  enableDevToolsExtension: stripQuotes(process.env.VITE_ENABLE_DEV_TOOLS_EXTENSION),
  enableLogs: stripQuotes(process.env.VITE_ENABLE_LOGS),
  signupIframeUrl:
    stripQuotes(process.env.VITE_SIGNUP_IFRAME_LINK) ||
    'https://www.chaserhq.com/chaser-login-page-iframe',
  environment: 'env_vars',
  isDebug: true,
  version: `${pkg.name}@${pkg.version}+${commitSha}`,
  commitSha,
  featureFlags: {},
};
